import { render, staticRenderFns } from "./IcoScormContent.vue?vue&type=template&id=35a216f9"
import script from "./IcoScormContent.vue?vue&type=script&lang=js"
export * from "./IcoScormContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports